import { Checkmark } from "./checkmark"

interface SuccessMessageProps {
    title?: string;
    description?: string;
}

export function SuccessMessage({
    title = "GNREs solicitadas com sucesso!",
    description = "Você receberá as notas por e-mail em alguns instantes. Fique à vontade para explorar o sistema enquanto processamos suas guias."
}: SuccessMessageProps) {
    return (
        <div className="flex flex-col items-center justify-center py-10 px-4 gap-6">
            <Checkmark size={80} strokeWidth={3} color="#22c55e" />
            <div className="text-center">
                <div className="text-lg font-semibold text-green-700 mb-2">{title}</div>
                <div className="text-sm text-muted-foreground max-w-xs mx-auto">
                    {description}
                </div>
            </div>
        </div>
    )
}
